import styled from 'styled-components';
import { H2 } from '../../../style/Typography';
import Icons from '../../Icons';
import { Images } from '../../Images';

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: 100;
  cursor: progress;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--global-container-bg);
`;

export const TransparentOverlay = styled(Overlay)`
  opacity: 0.6; // TODO
`;

export const Loading = styled(Icons.InProgress).attrs({
  rotate: true
})``;

export const ErrorImage = styled(Images.SomethingWentWrongLight)`
  width: 30%;
  min-width: 100px;
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImageMessageWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
`;

export const Message = styled(H2).attrs({ textTransform: 'unset' })`
  color: var(--label-color);
`;
